export const isLiveInventoryLinked = ({
  inventoryLinked,
  cloudAllocationId,
  deprovisionedAt,
}: {
  inventoryLinked?: boolean;
  cloudAllocationId?: string | null;
  deprovisionedAt?: Date | string | null;
}): boolean =>
  inventoryLinked ??
  (Boolean(cloudAllocationId) &&
    (deprovisionedAt === null || deprovisionedAt === undefined));

export const shouldShowUnmatchedInventory = ({
  inventoryLinked,
  cloudAllocationId,
  deprovisionedAt,
}: {
  cloudProvider?: string | null;
  inventoryLinked?: boolean;
  cloudAllocationId?: string | null;
  deprovisionedAt?: Date | string | null;
}): boolean => {
  if (!cloudAllocationId) {
    return false;
  }

  return !isLiveInventoryLinked({
    inventoryLinked,
    cloudAllocationId,
    deprovisionedAt,
  });
};
